import styled from 'styled-components'


const FullScreenContainer = styled.div`
  margin: 0;
  padding: 0;
  height: 100dvh;
  width: 100vw;
  overflow: hidden;
  position: relative;
`

export default FullScreenContainer